import * as React from 'react';
import { FunctionComponent } from 'react';
import { SimpleSidebarItem } from './Sidebar';
import { NavLink } from 'react-router-dom';
import { AppUser } from 'Src/views/App/App';
import { getUserActiveSchoolSubscriptionPlan } from '../../helpers/user/user';

interface Props {
  item: SimpleSidebarItem;
  user: AppUser;
}

export const SidebarItem: FunctionComponent<Props> = props => {
  const { user, item } = props;
  const {
    itemTitle,
    to,
    visibleToSchoolSubscriptions,
    notificationCount,
    isNew,
    activePathPrefixes = [],
    icon,
    alwaysVisible
  } = item;

  const renderIcon = () => {
    if (!icon) return null;

    const paths = {
      home: (
        <>
          <path d="M3 11.5 12 4l9 7.5" />
          <path d="M5.5 10.5V20h13v-9.5M9.5 20v-6h5v6" />
        </>
      ),
      calendar: (
        <>
          <rect x="3.5" y="5" width="17" height="15" rx="2.5" />
          <path d="M8 3v4M16 3v4M3.5 9h17" />
        </>
      ),
      children: (
        <>
          <circle cx="9" cy="8" r="3" />
          <circle cx="17" cy="9" r="2.5" />
          <path d="M3.5 20c.4-4 2.2-6 5.5-6s5.1 2 5.5 6M14 15c3.7-.8 5.8.9 6.5 4" />
        </>
      ),
      teams: (
        <>
          <circle cx="8" cy="8" r="3" /><circle cx="17" cy="9" r="2.5" />
          <path d="M2.5 20c.4-4 2.2-6 5.5-6s5.1 2 5.5 6M13.5 15c3.8-.8 6 .9 7 4" />
        </>
      ),
      awards: (
        <>
          <path d="M8 4h8v3a4 4 0 0 1-8 0V4zM8 5H5a2 2 0 0 0 2 4h1M16 5h3a2 2 0 0 1-2 4h-1M12 11v5M8.5 20h7" />
        </>
      ),
      consent: (
        <>
          <path d="M7 3.5h10a2 2 0 0 1 2 2v15H5v-15a2 2 0 0 1 2-2z" />
          <path d="M8 8h8M8 12h5M8 16l1.5 1.5L13 14" />
        </>
      ),
      clubs: (
        <>
          <path d="M12 3 4.5 7v10L12 21l7.5-4V7L12 3zM4.5 7 12 11l7.5-4M12 11v10" />
        </>
      ),
      availability: (
        <>
          <circle cx="12" cy="12" r="8.5" />
          <path d="M12 7v5l3.5 2M8 3.5 6 2M16 3.5 18 2" />
        </>
      ),
      absence: (
        <>
          <path d="M6 3.5h12v17H6zM9 8h6M9 12h6M9 16h3" />
          <path d="m16.5 15.5 4 4M20.5 15.5l-4 4" />
        </>
      )
    };

    return (
      <svg className="eSidebarItemIcon" viewBox="0 0 24 24" aria-hidden="true">
        {paths[icon]}
      </svg>
    );
  };

  const isNotificationExist = typeof notificationCount !== 'undefined';
  const isNotificationToShow = isNotificationExist && Number(notificationCount) > 0;

  const isVisible =
    alwaysVisible ||
    visibleToSchoolSubscriptions.some(subscription => subscription === getUserActiveSchoolSubscriptionPlan(user));

  return isVisible ? (
    <NavLink
      className="nav-link eSidebarItem"
      to={to}
      isActive={(_match, location) =>
        location.pathname.indexOf(to.pathname) === 0 ||
        activePathPrefixes.some(prefix => location.pathname.indexOf(prefix) === 0)
      }
    >
      <div className="eSidebarItemNotificationWrapper">
        {renderIcon()}
        <span className="eSidebarItemTitle">{itemTitle}</span>

        <span className="eSidebarItemRight">
          {isNew && <span className="eSidebarItemNew">NEW</span>}
          {isNotificationToShow && <span className="eSidebarItemNotification">{notificationCount}</span>}
        </span>
      </div>
    </NavLink>
  ) : null;
};

SidebarItem.displayName = 'SidebarItem';
